module.exports = __webpack_public_path__ + "img/20.b0203f10.png";